import React from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import './App.css'
import About from './pages/About'
import Contact from './pages/Contact'
import Gospel from './pages/Gospel'
import Home from './pages/Home/Home'
import NotFound from './pages/NotFound'

function App() {
  const location = useLocation()

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' })
  }, [location])
  return (
    <div className='App font-sans'>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/gospel' element={<Gospel />} />
        {/* <Route path="/explore" element={<Explore />} /> */}
        <Route path='/contact' element={<Contact />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </div>
  )
}

export default App
